<span class="w-full not-found-container flex flex-col gap-4 items-center justify-center">
    <span class="text-2xl font-medium">Page introuvable</span>
    <a [routerLink]="['/sessions']">Cliquez ici pour revenir à la page d'accueil</a>
</span>